import styled from 'styled-components';

export const HomeWrap = styled.div`
  .result {
    line-height: 180%;
    font-size: ${(props) => props.theme.fontSizes[4]};
    color: ${(props) => props.theme.colors.base.primary};
  }
`;
